import { render, staticRenderFns } from "./my-list.vue?vue&type=template&id=25c7f1e3"
import script from "./my-list.vue?vue&type=script&lang=js"
export * from "./my-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports